
const DEFAULT_TYPOGRAPHY_STYLES = {
  h1: {
    fontSize: '2rem',
    fontWeight: 800,
    lineHeight: '1.18',
    [`@media (max-width:830px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.20',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.20',
    },
  },
  h2: {
    fontSize: '1.75rem',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:830px)`]: {
      fontSize: '1.3rem',
      lineHeight: '1.27',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.3rem',
      lineHeight: '1.27',
    },
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:830px)`]: {
      fontSize: '1.25rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.25rem',
      lineHeight: '1.32',
    },
  },
  h4: {
    fontSize: '1.375rem',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:830px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 800,
    lineHeight: '1.28',
    [`@media (max-width:830px)`]: {
      fontSize: '1rem',
      lineHeight: '1.28',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.28',
    },
  },
  h6: {
    fontSize: '1.125rem',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:830px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.24',
    },
  },
  subtitle1: {
    fontSize: '1.3rem',
    fontWeight: 700,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: '1.1rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.1rem',
      lineHeight: '1.32',
    },
  },
  subtitle2: {
    fontSize: '1.125rem',
    fontWeight: 700,
    lineHeight: '1.32',
    [`@media (max-width:830px)`]: {
      fontSize: '1rem',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.24',
    },
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:830px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.56',
    },
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: '0.8125rem',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.8125rem',
      lineHeight: '1.4',
    },
  },
  caption: {
    fontSize: 'clamp(0.5rem, 0.75rem, 0.875rem)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
  },
  buttoninput: {
    fontSize: '1.25rem', // body1과 동일
    fontWeight: 700,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: '1.25rem',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
    },
  },
  pagination: {
    fontSize: 'clamp(0.625rem, 0.875rem, 1rem)', // body2와 동일하게 작게
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
  },
  textarea: {
    fontSize: '1.3rem',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
  },
};

const CLAMP_TYPOGRAPHY_STYLES = {
  h1: {
    fontSize: 'clamp(1.5rem, 2rem, 2.5rem)',
    fontWeight: 800,
    lineHeight: '1.18',
    [`@media (max-width:830px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.20',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.20',
    },
  },
  h2: {
    fontSize: 'clamp(1.5rem, 1.75rem, 2rem)',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:830px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.27',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.27',
    },
  },
  h3: {
    fontSize: 'clamp(1.25rem, 1.5rem, 1.75rem)',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:830px)`]: {
      fontSize: '1.25rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.25rem',
      lineHeight: '1.32',
    },
  },
  h4: {
    fontSize: 'clamp(1.125rem, 1.375rem, 1.5rem)',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:830px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
  },
  h5: {
    fontSize: 'clamp(1rem, 1.25rem, 1.375rem)',
    fontWeight: 800,
    lineHeight: '1.28',
    [`@media (max-width:830px)`]: {
      fontSize: '1rem',
      lineHeight: '1.28',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.28',
    },
  },
  h6: {
    fontSize: 'clamp(0.9375rem, 1.125rem, 1.25rem)',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:830px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.24',
    },
  },
  subtitle1: {
    fontSize: 'clamp(1.1rem, 1.3rem, 1.5rem)',
    fontWeight: 800,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: '1.1rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.1rem',
      lineHeight: '1.32',
    },
  },
  subtitle2: {
    fontSize: 'clamp(1rem, 1.125rem, 1.25rem)',
    fontWeight: 800,
    lineHeight: '1.32',
    [`@media (max-width:830px)`]: {
      fontSize: '1rem',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.24',
    },
  },
  body1: {
    fontSize: 'clamp(0.9375rem, 1rem, 1.125rem)',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:830px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.56',
    },
  },
  body2: {
    fontSize: 'clamp(0.8125rem, 0.875rem, 1rem)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: '0.8125rem',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.8125rem',
      lineHeight: '1.4',
    },
  },
  caption: {
    fontSize: 'clamp(0.5rem, 0.75rem, 0.875rem)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
  },
  buttoninput: {
    fontSize: 'clamp(0.75rem, 1rem, 1.125rem)', // body1과 동일
    fontWeight: 700,
    lineHeight: '1.48',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
  },
  pagination: {
    fontSize: 'clamp(0.625rem, 0.875rem, 1rem)', // body2와 동일하게 작게
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
  },
  textarea: {
    fontSize: '1.3rem',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
  },
};

const FLUID_TYPOGRAPHY_STYLES = {
  h1: {
    fontSize: 'var(--step-2)',
    fontWeight: 800,
    lineHeight: '1.18',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step-1)',
      lineHeight: '1.20',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-1)',
      lineHeight: '1.20',
    },
  },
  h2: {
    fontSize: 'var(--step-1)',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step-1)',
      lineHeight: '1.27',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-1)',
      lineHeight: '1.27',
    },
  },
  h3: {
    fontSize: 'var(--step-0)',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
  },
  h4: {
    fontSize: 'var(--step--1)',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
  },
  h5: {
    fontSize: 'var(--step--1)',
    fontWeight: 800,
    lineHeight: '1.28',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.28',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.28',
    },
  },
  h6: {
    fontSize: 'var(--step--1)',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.24',
    },
  },
  subtitle1: {
    fontSize: 'var(--step--1)',
    fontWeight: 800,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
  },
  subtitle2: {
    fontSize: 'var(--step-0)',
    fontWeight: 800,
    lineHeight: '1.32',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.24',
    },
  },
  body1: {
    fontSize: 'var(--step-0)',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.56',
    },
  },
  body2: {
    fontSize: 'var(--step--1)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.4',
    },
  },
  caption: {
    fontSize: 'clamp(0.5rem, 0.75rem, 0.875rem)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
  },
  buttoninput: {
    fontSize: 'clamp(0.75rem, 1rem, 1.125rem)', // body1과 동일
    fontWeight: 700,
    lineHeight: '1.48',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
  },
  pagination: {
    fontSize: 'clamp(0.625rem, 0.875rem, 1rem)', // body2와 동일하게 작게
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
  },
  textarea: {
    fontSize: 'var(--step-1)',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:830px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.56',
    },
  },
};


const CONTENT_TYPOGRAPHY_STYLES = {
  clampH1: {
    fontSize: 'clamp(16px, 2vw, 32px)',
    fontWeight: 800,
    lineHeight: '1.24',
    fontFamily: 'Elice DX Neolli'
  },
  h1: {
    fontSize: '2rem',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:830px)`]: {
      fontSize: '1.5rem',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.5rem',
    },
  },
  h2: {
    fontSize: '1.75rem',
    fontWeight: 800,
    lineHeight: '1.5',
    [`@media (max-width:830px)`]: {
      fontSize: '1.3rem',
      lineHeight: '1.27',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.3rem',
      lineHeight: '1.27',
    },
  },
  h3: {
    fontSize: '1.75rem',
    fontWeight: 700,
    lineHeight: '1.5',
    [`@media (max-width:830px)`]: {
      fontSize: '1.3rem',
      lineHeight: '1.27',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.3rem',
      lineHeight: '1.27',
    },
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: '1.3',
    [`@media (max-width:830px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
  },
  h5: {
    fontSize: '1.5rem',
    fontWeight: 400,
    lineHeight: '1.5',
    [`@media (max-width:830px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
  },
  h6: {
    fontSize: '1.375rem',
    fontWeight: 500,
    lineHeight: '1.24',
    [`@media (max-width:830px)`]: {
      fontSize: '1rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.32',
    },
  },
  subtitle1: {
    fontSize: '2rem', // 32px
    fontWeight: 600,
    lineHeight: '1.2',
    letterSpacing: '-0.32px',
    [`@media (max-width:830px)`]: {
      fontSize: '1.5rem',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.5rem',
    },
  },
  subtitle2: {
    fontSize: '1.75rem', // 28px
    fontWeight: 400,
    lineHeight: '1.5',
    [`@media (max-width:830px)`]: {
      fontSize: '1.3rem',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.3rem',
    },
  },
  subtitle3: {
    fontSize: '1.125rem', // 18px
    fontWeight: 600,
    lineHeight: '1.32',
    [`@media (max-width:830px)`]: {
      fontSize: '1rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.32',
    },
  },
  body1: {
    fontSize: '1.25rem', // 20px
    fontWeight: 400,
    lineHeight: '1.3',
    [`@media (max-width:830px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.3',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.3',
    },
  },
  body2: {
    fontSize: '1.125rem', // 18px
    fontWeight: 400,
    lineHeight: '1.5',
    [`@media (max-width:830px)`]: {
      fontSize: '1rem',
      lineHeight: '1.5',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.5',
    },
  },
  body3: {
    fontSize: '1rem', // 16px
    fontWeight: 400,
    lineHeight: '1.5',
    [`@media (max-width:830px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.5',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.5',
    },
  },
  caption: {
    fontSize: '0.938rem', // 15px
    fontWeight: 300,
    lineHeight: '1.5',
    [`@media (max-width:830px)`]: {
      fontSize: '0.875rem',
      lineHeight: '1.5',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.875rem',
      lineHeight: '1.5',
    },
  },
  title1: {
    fontSize: '2.25rem', // 36px
    fontWeight: 800,
    lineHeight: '1.5',
    [`@media (max-width:830px)`]: {
      fontSize: '1.75rem',
      lineHeight: '1.5',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.75rem',
      lineHeight: '1.5',
    },
  },
  title2: {
    fontSize: '2.25rem', // 36px
    fontWeight: 700,
    lineHeight: '1.5',
    [`@media (max-width:830px)`]: {
      fontSize: '1.75rem',
      lineHeight: '1.5',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.75rem',
      lineHeight: '1.5',
    },
  },
  buttoninput: {
    fontSize: '1.25rem', // body1과 동일
    fontWeight: 700,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: '1rem',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
    },
  },
  pagination: {
    fontSize: 'clamp(0.625rem, 2vw, 1rem)', // body2와 동일하게 작게
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.5rem, 2vw, 0.875rem)',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.5rem, 2vw, 0.875rem)',
      lineHeight: '1.4',
    },
  },  
  textarea: {
    fontSize: '1.3rem',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:830px)`]: {
      fontSize: 'clamp(0.625rem, 2vw, 1rem)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.625rem, 2vw, 1rem)',
      lineHeight: '1.56',
    },
  },
};

// 공식: clamp(min-rem, intercept + slope_vw*vw + slope_vh*vh, max-rem)
// 기준 뷰포트: 768px(min) → 1280px(max) width, height 600px~900px
// vw: 너비 반응, vh: 높이 반응 (짧은 화면에서 폰트 축소)
const CONTENT_CLAMP_TYPOGRAPHY_STYLES = {
  // 14px → 28px | min/max 축소, vh 반응 추가
  clampH1: {
    fontSize: 'clamp(0.875rem, -0.6rem + 2.8vw + 0.15vh, 1.75rem)',
    fontWeight: 800,
    lineHeight: '1.24',
    fontFamily: 'Elice DX Neolli',
  },
  // 21px → 28px
  h1: {
    fontSize: 'clamp(1.3125rem, 0.6rem + 1.4vw + 0.12vh, 1.75rem)',
    fontWeight: 800,
    lineHeight: '1.24',
  },
  // 18px → 24px
  h2: {
    fontSize: 'clamp(1.125rem, 0.5rem + 1.2vw + 0.1vh, 1.5rem)',
    fontWeight: 800,
    lineHeight: '1.5',
  },
  h3: {
    fontSize: 'clamp(1.125rem, 0.5rem + 1.2vw + 0.1vh, 1.5rem)',
    fontWeight: 700,
    lineHeight: '1.5',
  },
  // 15px → 20px
  h4: {
    fontSize: 'clamp(0.9375rem, 0.45rem + 1vw + 0.08vh, 1.25rem)',
    fontWeight: 600,
    lineHeight: '1.3',
  },
  h5: {
    fontSize: 'clamp(0.9375rem, 0.45rem + 1vw + 0.08vh, 1.25rem)',
    fontWeight: 400,
    lineHeight: '1.5',
  },
  // 14px → 19px
  h6: {
    fontSize: 'clamp(0.875rem, 0.35rem + 1vw + 0.08vh, 1.1875rem)',
    fontWeight: 500,
    lineHeight: '1.32',
  },
  // 21px → 28px (h1과 동일)
  subtitle1: {
    fontSize: 'clamp(1.3125rem, 0.6rem + 1.4vw + 0.12vh, 1.75rem)',
    fontWeight: 600,
    lineHeight: '1.2',
    letterSpacing: '-0.32px',
  },
  // 18px → 24px (h2와 동일)
  subtitle2: {
    fontSize: 'clamp(1.125rem, 0.5rem + 1.2vw + 0.1vh, 1.5rem)',
    fontWeight: 400,
    lineHeight: '1.5',
  },
  // 14px → 16px
  subtitle3: {
    fontSize: 'clamp(0.875rem, 0.7rem + 0.35vw + 0.06vh, 1rem)',
    fontWeight: 600,
    lineHeight: '1.32',
  },
  // 16px → 18px
  body1: {
    fontSize: 'clamp(1rem, 0.8rem + 0.35vw + 0.06vh, 1.125rem)',
    fontWeight: 400,
    lineHeight: '1.3',
  },
  // 14px → 16px
  body2: {
    fontSize: 'clamp(0.875rem, 0.7rem + 0.35vw + 0.06vh, 1rem)',
    fontWeight: 400,
    lineHeight: '1.5',
  },
  // 13px → 14px
  body3: {
    fontSize: 'clamp(0.8125rem, 0.65rem + 0.2vw + 0.05vh, 0.875rem)',
    fontWeight: 400,
    lineHeight: '1.5',
  },
  // 12px → 13px
  caption: {
    fontSize: 'clamp(0.75rem, 0.6rem + 0.2vw + 0.05vh, 0.8125rem)',
    fontWeight: 300,
    lineHeight: '1.5',
  },
  // 24px → 32px
  title1: {
    fontSize: 'clamp(1.5rem, 0.85rem + 1.4vw + 0.12vh, 2rem)',
    fontWeight: 800,
    lineHeight: '1.5',
  },
  title2: {
    fontSize: 'clamp(1.5rem, 0.85rem + 1.4vw + 0.12vh, 2rem)',
    fontWeight: 700,
    lineHeight: '1.5',
  },
  // 14px → 18px
  buttoninput: {
    fontSize: 'clamp(0.875rem, 0.5rem + 0.65vw + 0.06vh, 1.125rem)',
    fontWeight: 700,
    lineHeight: '1.4',
  },
  // 9px → 14px
  pagination: {
    fontSize: 'clamp(0.5625rem, 0rem + 0.9vw + 0.05vh, 0.875rem)',
    fontWeight: 500,
    lineHeight: '1.4',
  },
  // 14px → 18px
  textarea: {
    fontSize: 'clamp(0.875rem, 0.45rem + 0.8vw + 0.06vh, 1.125rem)',
    fontWeight: 500,
    lineHeight: '1.48',
  },
};

export const TYPOGRAPHY_STYLES_MAP = {
  Default: DEFAULT_TYPOGRAPHY_STYLES,
  Fluid: FLUID_TYPOGRAPHY_STYLES,
  Clamp: CLAMP_TYPOGRAPHY_STYLES,
  Content: CONTENT_TYPOGRAPHY_STYLES,
  ContentClamp: CONTENT_CLAMP_TYPOGRAPHY_STYLES,
};

/** Default / Fluid / Clamp 공통 variant (Content 전용 variant 제외) */
export type BaseTypographyVariant = keyof typeof DEFAULT_TYPOGRAPHY_STYLES;

/** typographyType: 'Content' | 'ContentClamp' 일 때만 사용 가능한 variant */
export type ContentTypographyVariant = keyof typeof CONTENT_TYPOGRAPHY_STYLES;
